import { createContext } from "react";
import { UserType } from "../../hooks/api/Login/interfaces/userInfo.response";

type UserInfoResponse = {
  id: number;
  name: string;
  type: UserType;
  email: string;
};

export interface AuthContextData {
  isSigned: boolean;
  signIn(token: string, user: UserInfoResponse): void;
  signInWithToken(token: string, user: { id: number; name: string; email: string; roles: string[] }, type: 'patient' | 'doctor'): Promise<void>;
  updateUserData(user: Partial<UserInfoResponse>): void;
  signOut: () => void;
  getToken(): string | null;
  getUserData(): UserInfoResponse;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export default AuthContext;
